const pillClass: Record<string, string> = {
  Active: 'pill-success',
  Enabled: 'pill-success',
  Approved: 'pill-success',
  Pending: 'pill-pending',
  Rejected: 'pill-failed',
  Disabled: 'pill-disabled',
  NotRegistered: 'pill-unknown'
};

const pillLabel: Record<string, string> = {
  NotRegistered: 'Not registered'
};

export function StatusPill({ status }: { status: string }) {
  const cls = pillClass[status] ?? 'pill-unknown';
  return <span className={`pill ${cls}`}>{pillLabel[status] ?? status}</span>;
}
